import SectionTitle from "@/components/base/SectionTitle";
import { testimonials } from "@/mocks/site";

export default function Testimonials() {
  return (
    <section
      className="w-full bg-background-100 border-y border-background-200"
      aria-labelledby="home-voice-title"
    >
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-16 md:py-20">
        <SectionTitle
          eyebrow="VOICES"
          title="读者怎么说"
          desc="来自追剧观众、剪辑爱好者与影视专业学生的反馈，也是我们持续整理合集的动力。"
        />
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {testimonials.map((item) => (
            <figure
              key={item.name}
              className="flex flex-col h-full bg-background-50 border border-background-200 rounded-lg p-5 md:p-6"
            >
              <div className="flex items-center gap-1 text-accent-500 mb-4" aria-label="五星好评">
                {[0, 1, 2, 3, 4].map((star) => (
                  <i key={star} className="ri-star-fill text-sm" aria-hidden="true" />
                ))}
              </div>
              <blockquote className="text-sm leading-relaxed text-foreground-700 flex-1">
                {item.content}
              </blockquote>
              <figcaption className="flex items-center gap-3 mt-5 pt-4 border-t border-background-200">
                <span className="w-11 h-11 rounded-full overflow-hidden bg-background-200 shrink-0">
                  <img
                    src={item.avatar}
                    alt={`${item.name} 头像`}
                    title={item.name}
                    className="w-full h-full object-cover object-top"
                  />
                </span>
                <span className="flex flex-col">
                  <span className="text-sm font-medium text-foreground-900">
                    {item.name}
                  </span>
                  <span className="text-xs text-foreground-500 mt-0.5">{item.role}</span>
                </span>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}